import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';
export const createProject = (projectData) => {
  return api.post(URLS.project, projectData, {
    headers: {
      needsToken: true
    }
  });
};

export const getProjectDetailsByID = (projectID) => {
  return api.get(URLS.project, {
    params: {
      id: projectID
    },
    headers: {
      needsToken: true
    }
  });
};

export const updateProject = (projectID, projectData) => {
  return api.put(URLS.project, projectData, {
    params: {
      id: projectID
    },

    headers: {
      needsToken: true
    }
  });
};

export const projectOrdersFilterList = () => {
  return api.get(URLS.projectOrdersFilterList, {
    headers: {
      needsToken: true
    }
  });
};

export const projectOrdersSortList = () => {
  return api.get(URLS.projectOrdersSortList, {
    headers: {
      needsToken: true
    }
  });
};

export const projectOrders = (projectFilterData) => {
  return api.post(URLS.projectOrders, projectFilterData, {
    headers: {
      needsToken: true
    }
  });
};

export const getaddProjectOrdersList = (orderFilterData) => {
  return api.post(URLS.addProjectOrders, orderFilterData, {
    headers: {
      needsToken: true
    }
  });
};

export const projectAllocate = (projectData) => {
  return api.put(URLS.projectAllocate, projectData, {
    headers: {
      needsToken: true
    }
  });
};

export const projectDeallocate = (projectData) => {
  return api.put(URLS.projectDeallocate, projectData, {
    headers: {
      needsToken: true
    }
  });
};

export const cancelProject = (projectID) => {
  return api.delete(URLS.project, {
    params: {
      id: projectID
    },
    headers: {
      needsToken: true
    }
  });
};

export const projectEnable = (projectID) => {
  return api.put(
    URLS.projectEnable,
    {
      id: projectID
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getProjectSortList = () => {
  return api.get(URLS.projectPreviewSortList, {
    headers: {
      needsToken: true
    }
  });
};

export const getProjectFilterList = () => {
  return api.get(URLS.projectPreviewFilterList, {
    headers: {
      needsToken: true
    }
  });
};

export const projectDashboardList = (projectData) => {
  return api.post(URLS.projectDashboard, projectData, {
    headers: {
      needsToken: true
    }
  });
};

export const createProjectActivityComment = (projectID, payload) => {
  return api.post(URLS.projectActivity, payload, {
    params: {
      id: projectID
    },
    headers: {
      needsToken: true
    }
  });
};

export const getProjectActivity = (projectID) => {
  return api.get(URLS.projectActivity, {
    params: {
      id: projectID
    },
    headers: {
      needsToken: true
    }
  });
};

export const deleteProjectActivityComment = (commentId) => {
  return api.delete(`${URLS.projectActivity}`, {
    params: {
      id: commentId
    },
    headers: {
      needsToken: true
    }
  });
};

export const updateProjectActivityComment = (commentId, payload) => {
  return api.put(`${URLS.projectActivity}`, payload, {
    params: {
      id: commentId
    },
    headers: {
      needsToken: true
    }
  });
};
